export default __webpack_public_path__ + "static/media/baseline-battery_charging_90-24px.a6c35a6f.svg";